import { DefaultValueConfig } from '@headless-workspace/config';
import { Image } from '@headless-workspace/typings';
import { ObjectHelpers, ValueHelpers } from '@headless-workspace/utils';
import { mapURLToImage } from '../../../client';
import { CapacityFormat, mapProductPriceData, ProductDetailVariantDTO, ProductPriceData } from '../../../server';

export type ProductDetailVariantValue = ProductPriceData & {
    id: string;
    name?: string;
    image: Image;
    thumbnailImage: Image;
    isAvailable: boolean;
    format: CapacityFormat;
};

export const extractVariantFormats = (variants: ProductDetailVariantValue[]): CapacityFormat[] => {
    const compareAlphabetically = (a: CapacityFormat, b: CapacityFormat) => a.localeCompare(b);
    return Array.from(new Set(variants.map((variant) => variant.format))).sort(compareAlphabetically);
};

// FIXME: this may be updated when API is ready with format
export const mapFormat = (format?: string | null) => {
    if (format === 'Mini') {
        return CapacityFormat.Mini;
    }
    return CapacityFormat.Standard;
};

export const mapProductDetailVariant = (dto: ProductDetailVariantDTO, currency: string): ProductDetailVariantValue => {
    return {
        id: dto.id,
        name: ValueHelpers.mapOptional(dto.name),
        thumbnailImage:
            mapURLToImage(dto.swatchImageUrl) ?? ObjectHelpers.createImageWithSrc(DefaultValueConfig.imagePlaceholder),
        image: mapURLToImage(dto.imageUrl) ?? ObjectHelpers.createImageWithSrc(DefaultValueConfig.imagePlaceholder),
        isAvailable: dto.isAvailable ?? true,
        format: mapFormat(dto.format),
        ...mapProductPriceData(dto, currency),
    };
};
